__turbopack_context__.v({
  "dropdown": "topic-dropdown-module-scss-module__DuEkCG__dropdown",
  "item": "topic-dropdown-module-scss-module__DuEkCG__item",
});
